import OfferAttachmentsArchive from './OfferAttachmentsArchive';

export { downloadOfferAttachments } from './downloadOfferAttachments';
export default OfferAttachmentsArchive;
